"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingEditor = void 0;
const firestore_1 = require("firebase/firestore");
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Col_1 = __importDefault(require("react-bootstrap/Col"));
const Container_1 = __importDefault(require("react-bootstrap/Container"));
const Row_1 = __importDefault(require("react-bootstrap/Row"));
const react_hot_keys_1 = __importDefault(require("react-hot-keys"));
const react_router_dom_1 = require("react-router-dom");
const authContext_1 = require("../../context/authContext");
const configContext_1 = require("../../context/configContext");
const environment_1 = require("../../environment");
const Booking_1 = require("../../models/Booking");
const CustomerBooking_1 = require("../../models/CustomerBooking");
const dateUtils = __importStar(require("../../utils/dateUtils"));
const useBackToLastLocation_1 = require("../../utils/useBackToLastLocation");
const useFirestore_1 = require("../../utils/useFirestore");
const BookingItemEditor_1 = require("../booking-item-editor/BookingItemEditor");
const IconAddCircleOutline_1 = require("../icons/IconAddCircleOutline");
const IconClear_1 = require("../icons/IconClear");
const IconContentCopy_1 = require("../icons/IconContentCopy");
const IconDelete_1 = require("../icons/IconDelete");
const IconOpenInNew_1 = require("../icons/IconOpenInNew");
const IconSave_1 = require("../icons/IconSave");
const ResourceCalendarModal_1 = require("../resource-calendar-modal/ResourceCalendarModal");
const SimpleModal_1 = require("../simple-modal/SimpleModal");
const Spinner_1 = require("../spinner/Spinner");
require("./BookingEditor.scss");
const CommentsByCustomerCard_1 = require("./cards/CommentsByCustomerCard");
const CommentsByStaffCard_1 = require("./cards/CommentsByStaffCard");
const ContactCard_1 = require("./cards/ContactCard");
const NotesCard_1 = require("./cards/NotesCard");
const PeopleCard_1 = require("./cards/PeopleCard");
const ResourceCard_1 = require("./cards/ResourceCard");
const StatusCard_1 = require("./cards/StatusCard");
const TitleCard_1 = require("./cards/TitleCard");
const usePrompt_1 = require("../../utils/usePrompt");
class FormState {
    constructor() {
        this.title = false;
        this.resource = false;
        this.people = false;
        this.notes = false;
        this.contact = false;
        this.status = false;
        this.items = false;
        this.commentsByCustomer = false;
        this.commentsByStaff = false;
    }
}
/**
 * Component for editing a booking or for creating a new booking.
 */
const BookingEditor = (props) => {
    var _a;
    const [modal, setModal] = (0, react_1.useState)();
    function showModal(newModal) {
        setModal(newModal);
    }
    function hideModal() {
        setModal(undefined);
    }
    const [booking, setBooking] = (0, react_1.useState)(props.booking);
    const [isSavingOrDeleting, setIsSavingOrDeleting] = (0, react_1.useState)(false);
    const [isDirty, setIsDirty] = (0, react_1.useState)(new FormState());
    function isSomeDirty() {
        return Object.values(isDirty).some((dirty) => dirty);
    }
    function clearDirty() {
        setIsDirty(new FormState());
    }
    // Block navigation if there are any unsaved changes.
    (0, usePrompt_1.usePrompt)({
        when: isSomeDirty(),
        message: "Manche Änderungen wurden noch nicht gespeichert. Änderungen verwerfen und weiter?",
    });
    // Block navigation if there are any unsaved changes.
    // unstable_usePrompt({
    //   when: isSomeDirty(),
    //   message:
    //     "Manche Änderungen wurden noch nicht gespeichert. Änderungen verwerfen und weiter?",
    // });
    // useBeforeUnload((event) => {
    //   if (isSomeDirty()) {
    //     // Cancel the event.
    //     event.preventDefault();
    //     // Chrome (and legacy IE) requires returnValue to be set.
    //     event.returnValue = "";
    //   }
    //   return;
    // });
    const config = (0, configContext_1.useConfig)();
    const firestore = (0, useFirestore_1.useFirestore)();
    const lastLocation = (0, useBackToLastLocation_1.useBackToLastLocation)(`/manager/${config.tenantId}/`);
    const [auth, authInfo] = (0, authContext_1.useAuth)();
    const isAdmin = authInfo.user.isAdminOf(config.tenantId) || authInfo.user.isSuperadmin;
    const isCreator = authInfo.user && booking.createdBy
        ? authInfo.user.id === booking.createdBy.id
        : false;
    const [isInvalid, setIsInvalid] = (0, react_1.useState)({
        ...new FormState(),
        // We set the resource date/time to invalid for new bookings so that the user must actively change it.
        resource: isBookingNew(),
    });
    function isSomeInvalid() {
        return Object.values(isInvalid).some((invalid) => invalid);
    }
    /** Returns true, if the booking is new. */
    function isBookingNew() {
        return booking.id === undefined;
    }
    function handleBookingChange(newBooking) {
        setBooking((prevBooking) => {
            if (prevBooking instanceof CustomerBooking_1.CustomerBooking) {
                const mergedBooking = CustomerBooking_1.CustomerBooking.fromPartial(newBooking, prevBooking, config);
                mergedBooking.update();
                return mergedBooking;
            }
            else {
                return Booking_1.Booking.fromPartial(newBooking, prevBooking, config);
            }
        });
    }
    function handleBookingItemChange(bookingItem, deleteItem) {
        setBooking((prevBooking) => {
            if (prevBooking instanceof CustomerBooking_1.CustomerBooking) {
                // We use the booking items generated key here for identification.
                // The table row index seems to get out of sync through debouncing!
                const newItems = Object.assign(new Array(), [
                    prevBooking.resourceItem,
                    ...prevBooking.addonItems,
                ]);
                const index = newItems.findIndex((item) => item.key === bookingItem.key);
                if (deleteItem) {
                    newItems.splice(index, 1);
                }
                else {
                    newItems[index] = bookingItem;
                }
                const [resourceItem, ...addonItems] = newItems;
                const mergedBooking = CustomerBooking_1.CustomerBooking.fromPartial({ resourceItem, addonItems }, prevBooking, config);
                mergedBooking.update();
                return mergedBooking;
            }
            else {
                return prevBooking;
            }
        });
    }
    async function handleSave() {
        var _a;
        // Cancel if there are invalid fields.
        if (isSomeInvalid()) {
            return;
        }
        setIsSavingOrDeleting(true);
        if (booking instanceof CustomerBooking_1.CustomerBooking) {
            booking.ensureNonEmptyItemAndDiscountTitles();
        }
        try {
            if (isBookingNew()) {
                // New booking.
                // Set created date and user.
                booking.created = new Date();
                booking.createdBy = (_a = authInfo.user) === null || _a === void 0 ? void 0 : _a.toBookingUser();
                // Add new reference number.
                const nextReferenceResponse = await fetch(`${(0, environment_1.getEnv)().baseUrl}/api/tenants/${config.tenantId}/nextReference`, {
                    headers: {
                        Authorization: await authInfo.getAuthHeader(),
                    },
                });
                const nextReference = await nextReferenceResponse.json();
                booking.reference = nextReference;
                const bookingDoc = await (0, firestore_1.addDoc)((0, firestore_1.collection)(firestore, "bookings"), booking.toJSON());
                booking.id = bookingDoc.id;
                clearDirty();
                setIsSavingOrDeleting(false);
                // Change the location history to show the booking reference.
                // Use history.replaceState directly because navigate() would react to (still) dirty state.
                history.replaceState({}, "", `/manager/${config.tenantId}/bookings/${booking.reference}/`);
            }
            else {
                // Existing booking was updated.
                await (0, firestore_1.setDoc)((0, firestore_1.doc)(firestore, "bookings", booking.id), booking.toJSON());
                clearDirty();
                setIsSavingOrDeleting(false);
            }
        }
        catch (error) {
            console.error(error);
            throw error;
        }
        clearDirty();
        setIsSavingOrDeleting(false);
    }
    async function handleDelete() {
        setIsSavingOrDeleting(true);
        try {
            // Save the updated booking.
            await (0, firestore_1.deleteDoc)((0, firestore_1.doc)(firestore, "bookings", booking.id));
        }
        catch (error) {
            console.error(error);
            throw error;
        }
        setIsSavingOrDeleting(false);
        handleClose();
    }
    function handleClose() {
        lastLocation.goBack();
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Container_1.default, { fluid: true, className: "booking-editor" },
            react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-between my-3" },
                react_1.default.createElement("div", { className: "d-flex" },
                    react_1.default.createElement("h1", { className: "mb-0" }, isBookingNew() ? ("Neue Buchung") : (react_1.default.createElement(react_1.default.Fragment, null,
                        "Buchung",
                        " ",
                        react_1.default.createElement("small", { className: "text-nowrap" }, booking.reference),
                        " ",
                        booking instanceof CustomerBooking_1.CustomerBooking && (react_1.default.createElement(react_router_dom_1.Link, { className: "no-print", to: `/bookings/${booking.id}/`, title: "Kundenansicht \u00F6ffnen", target: "_blank" },
                            react_1.default.createElement(IconOpenInNew_1.IconOpenInNew, { size: "0.6em", className: "align-top" }))))))),
                isSomeDirty() && !isSavingOrDeleting && (react_1.default.createElement("div", { className: "text-warning text-center mx-3 d-none d-sm-block" }, "ungespeicherte \u00C4nderungen")),
                isSavingOrDeleting && react_1.default.createElement(Spinner_1.Spinner, null),
                react_1.default.createElement("div", { className: "text-right no-print" },
                    react_1.default.createElement(Button_1.default, { variant: "primary", className: "my-1 text-nowrap", style: { minWidth: "125px" }, onClick: handleSave, title: "Speichern (ctrl+s)", disabled: !isSomeDirty() || isSomeInvalid() || isSavingOrDeleting },
                        react_1.default.createElement(IconSave_1.IconSave, null),
                        " Speichern"),
                    " ",
                    react_1.default.createElement(Button_1.default, { variant: "secondary", className: "my-1 text-nowrap", style: { minWidth: "125px" }, onClick: handleClose },
                        react_1.default.createElement(IconClear_1.IconClear, null),
                        " Schliessen"))),
            react_1.default.createElement(Row_1.default, null,
                react_1.default.createElement(Col_1.default, { sm: 6, lg: 4, className: "d-flex flex-column" },
                    react_1.default.createElement(TitleCard_1.TitleCard, { className: "mb-3", booking: booking, onBookingChange: (newBooking) => {
                            handleBookingChange(newBooking);
                            setIsDirty((prev) => ({ ...prev, title: true }));
                        }, isDirty: isDirty.title, isInvalid: isInvalid.title, isInvalidChange: (invalid) => {
                            setIsInvalid((prev) => ({ ...prev, title: invalid }));
                        } }),
                    react_1.default.createElement(ResourceCard_1.ResourceCard, { className: "mb-2 flex-grow-1", booking: booking, onBookingChange: (newBooking) => {
                            handleBookingChange(newBooking);
                            setIsDirty((prev) => ({ ...prev, resource: true }));
                            // Must set invalid to false because for new bookings it is invalid
                            // to force the user to actively interact with the time/date.
                            setIsInvalid((prev) => ({ ...prev, resource: false }));
                        }, isDirty: isDirty.resource, isInvalid: isInvalid.resource, 
                        // Admins can edit all bookings.
                        // Non-admins are only allowed to edit simple, non-customer bookings.
                        editable: isAdmin || !(booking instanceof CustomerBooking_1.CustomerBooking) }),
                    booking instanceof CustomerBooking_1.CustomerBooking && (react_1.default.createElement(StatusCard_1.StatusCard, { className: "", booking: booking, onBookingChange: (booking) => {
                            setIsDirty((prev) => ({ ...prev, status: true }));
                            handleBookingChange(booking);
                        }, isDirty: isDirty.status, editable: isAdmin }))),
                react_1.default.createElement(Col_1.default, { sm: 6, lg: 4, className: "flex-grow-1 d-flex flex-column" },
                    react_1.default.createElement(NotesCard_1.NotesCard, { className: "flex-grow-1 mt-3 mt-sm-0", isDirty: isDirty.notes, booking: booking, onBookingChange: (newBooking) => {
                            setIsDirty((prev) => ({ ...prev, notes: true }));
                            handleBookingChange(newBooking);
                        } })),
                !(booking instanceof CustomerBooking_1.CustomerBooking) &&
                    ((_a = booking.configResource) === null || _a === void 0 ? void 0 : _a.visible) &&
                    isAdmin && (react_1.default.createElement(Col_1.default, { sm: 12, className: "mt-4" },
                    react_1.default.createElement(Button_1.default, { variant: "outline-dark", onClick: () => {
                            const newBooking = CustomerBooking_1.CustomerBooking.fromBooking(booking, config);
                            newBooking.update();
                            setBooking(newBooking);
                        } },
                        react_1.default.createElement(IconAddCircleOutline_1.IconAddCircleOutline, null),
                        " Kunde hinzuf\u00FCgen"))),
                booking instanceof CustomerBooking_1.CustomerBooking && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Col_1.default, { sm: 12, lg: 4, className: "flex-grow-1 d-flex flex-column" },
                        react_1.default.createElement(ContactCard_1.ContactCard, { className: "mt-3 mt-lg-0 flex-grow-1", booking: booking, onBookingChange: (booking) => {
                                setIsDirty((prev) => ({ ...prev, contact: true }));
                                handleBookingChange(booking);
                            }, isDirty: isDirty.contact, isInvalid: isInvalid.contact, isInvalidChange: (invalid) => {
                                setIsInvalid((prev) => ({ ...prev, contact: invalid }));
                            }, editable: isAdmin }),
                        react_1.default.createElement(Row_1.default, null,
                            react_1.default.createElement(Col_1.default, { sm: 6, lg: 12 },
                                react_1.default.createElement(PeopleCard_1.PeopleCard, { className: "", booking: booking, onBookingChange: (newBooking) => {
                                        setIsDirty((prev) => ({ ...prev, people: true }));
                                        handleBookingChange(newBooking);
                                    }, isDirty: isDirty.people })))),
                    react_1.default.createElement(Col_1.default, { sm: 12 },
                        react_1.default.createElement(BookingItemEditor_1.BookingItemEditor, { className: "mt-3 mt-sm-4", booking: booking, onBookingChange: (booking) => {
                                setIsDirty((prev) => ({ ...prev, items: true }));
                                handleBookingChange(booking);
                            }, onBookingItemChange: (item, deleteItem) => {
                                setIsDirty((prev) => ({ ...prev, items: true }));
                                handleBookingItemChange(item, deleteItem);
                            }, isDirty: isDirty.items, editable: isAdmin })),
                    react_1.default.createElement(Col_1.default, { sm: 6, className: "flex-grow-1 d-flex" },
                        react_1.default.createElement(CommentsByCustomerCard_1.CommentsByCustomerCard, { className: "mt-4 flex-grow-1", isDirty: isDirty.commentsByCustomer, booking: booking, onBookingChange: (booking) => {
                                setIsDirty((prev) => ({
                                    ...prev,
                                    commentsByCustomer: true,
                                }));
                                handleBookingChange(booking);
                            }, editable: isAdmin })),
                    react_1.default.createElement(Col_1.default, { sm: 6, className: "flex-grow-1 d-flex" },
                        react_1.default.createElement(CommentsByStaffCard_1.CommentsByStaffCard, { className: "mt-4 flex-grow-1", isDirty: isDirty.commentsByStaff, booking: booking, onBookingChange: (booking) => {
                                setIsDirty((prev) => ({ ...prev, commentsByStaff: true }));
                                handleBookingChange(booking);
                            }, editable: isAdmin }))))),
            react_1.default.createElement("div", { className: "d-flex my-3 justify-content-between" },
                react_1.default.createElement("dl", null,
                    react_1.default.createElement("dt", null, "Buchung erstellt"),
                    react_1.default.createElement("dd", null,
                        react_1.default.createElement("div", { className: "strong" }, booking.createdBy ? booking.createdBy.name : ""),
                        react_1.default.createElement("div", null, booking.created
                            ? `${dateUtils.formatDate(booking.created)} ${dateUtils.formatTime(booking.created)}`
                            : "---"))),
                (isAdmin || isCreator) && (react_1.default.createElement("div", { className: "no-print" },
                    react_1.default.createElement(Button_1.default, { variant: "light", size: "sm", onClick: () => showModal(react_1.default.createElement(ResourceCalendarModal_1.ResourceCalendarModal, { booking: booking, eventTitle: "Duplizieren", eventKeepSelf: true, onClose: hideModal, onOk: (newBooking) => {
                                // Reset the booking id and reference to force creating a new booking when saved.
                                newBooking.id = undefined;
                                newBooking.reference = undefined;
                                if (newBooking instanceof CustomerBooking_1.CustomerBooking) {
                                    // Reset invoice date, due date, and payments.
                                    newBooking.invoiceDate = undefined;
                                    newBooking.dueDate = undefined;
                                    newBooking.payments = [];
                                    // Update because of invoice status.
                                    newBooking.update();
                                }
                                setIsDirty((prev) => ({ ...prev, resource: true }));
                                handleBookingChange(newBooking);
                                hideModal();
                            } })), disabled: isSavingOrDeleting },
                        react_1.default.createElement(IconContentCopy_1.IconContentCopy, null),
                        " Duplizieren"),
                    " ",
                    react_1.default.createElement(Button_1.default, { className: "text-danger", variant: "light", size: "sm", onClick: () => {
                            showModal(react_1.default.createElement(SimpleModal_1.SimpleModal, { className: "booking-item-table-card-modal", title: "\uD83D\uDE2E Buchung l\u00F6schen?", body: react_1.default.createElement("p", null, "Soll ich die Buchung wirklich l\u00F6schen?"), onClose: hideModal, onOk: () => {
                                    handleDelete();
                                    hideModal();
                                } }));
                        }, disabled: isSavingOrDeleting },
                        react_1.default.createElement(IconDelete_1.IconDelete, null),
                        " L\u00F6schen"))))),
        react_1.default.createElement(react_hot_keys_1.default, { keyName: "ctrl+s,command+s", onKeyDown: (shortcut, evn, handle) => {
                evn.preventDefault();
                // Only save if there is a change.
                if (isSomeDirty()) {
                    handleSave();
                }
            }, filter: (event) => true }),
        react_1.default.createElement(react_hot_keys_1.default, { keyName: "esc", onKeyDown: (shortcut, evn, handle) => {
                const modalOpen = document.body.classList.contains("modal-open");
                if (!modalOpen) {
                    evn.preventDefault();
                    handleClose();
                }
            }, filter: (event) => true }),
        modal));
};
exports.BookingEditor = BookingEditor;
